import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
} from "chart.js";
import { Bar, Doughnut, Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
);

function ChartsSection({ data }) {

  const lineData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Client Growth",
        data: data.monthlyClients,
        borderColor: "#b8860b",
        backgroundColor: "rgba(184,134,11,0.2)",
        tension: 0.4
      }
    ]
  };

  const projectData = {
    labels: ["Residential", "Commercial", "Villa", "Office"],
    datasets: [
      {
        data: Object.values(data.projectTypes),
        backgroundColor: [
          "#8d6e63",
          "#a1887f",
          "#bcaaa4",
          "#d7ccc8"
        ]
      }
    ]
  };

  const resourceData = {
    labels: ["Suppliers", "Workers"],
    datasets: [
      {
        label: "Resources",
        data: Object.values(data.resources),
        backgroundColor: ["#6d4c41", "#b8860b"]
      }
    ]
  };

  return (
    <div className="row">

      <div className="col-md-6 mb-4">
        <div className="card p-4">
          <h6>Monthly Client Growth</h6>
          <Line data={lineData} />
        </div>
      </div>

      <div className="col-md-6 mb-4">
        <div className="card p-4">
          <h6>Project Distribution</h6>
          <Doughnut data={projectData} />
        </div>
      </div>

      <div className="col-md-12">
        <div className="card p-4">
          <h6>Site Resources Overview</h6>
          <Bar data={resourceData} />
        </div>
      </div>

    </div>
  );
}

export default ChartsSection;
